import { useEffect, useState } from 'react';
import { ContentHeader, Table } from '@app/shared';
import { useMemoCategories } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../../components/MasterDetailLayout';
import { MemoCategoryForm } from './MemoCategoryForm';
import { Segment } from 'semantic-ui-react';
import { toFormattedDate } from '@app/utilities';

export function MemoCategories() {
  const [selectedMemoCategory, setSelectedMemoCategory] = useState(undefined as any);
  const { data: memoCategories } = useMemoCategories(true);
  const [memoCategory, setMemoCategory] = useState();
  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'Id' },
    { field: 'code', headerName: 'Code' },
    { field: 'owningTeams', headerName: 'Owning Teams', valueFormatter: (params) => params.value?.join(',') },
    { field: 'expiryDate', headerName: 'Expiry Date', valueFormatter: (params) => toFormattedDate(params.value) },
  ];

  useEffect(() => {
    if (!selectedMemoCategory) {
      setMemoCategory(null);
      return;
    }
    setMemoCategory(selectedMemoCategory);
  }, [selectedMemoCategory]);

  const master = (
    <>
      <ContentHeader>
        Memo Categories
        <button
          disabled
          className={'ui button'}
          onClick={() => {
            setMemoCategory(undefined);
            setSelectedMemoCategory(undefined);
          }}>
          Add Memo Category
        </button>
      </ContentHeader>
      <div style={{ height: 'calc(100% - 100px)' }}>
        <Table
          items={memoCategories ? memoCategories.categories : []}
          onSelectItem={setSelectedMemoCategory}
          columnDefs={columnDefs}
        />
      </div>
    </>
  );

  const detail = (
    <Segment>
      <ContentHeader>{memoCategory ? 'Update Memo Category' : 'Add Memo Category'}</ContentHeader>
      <MemoCategoryForm key={JSON.stringify(memoCategory)} memoCategory={memoCategory} />
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
